<script setup lang="ts">
const props = defineProps<{
  sekou_cd?: string | number;
  kouji_cd?: string | number;
  plan_cd?: string | number;
}>();

const query = computed(() => {
  const query: { [key: string]: any } = {};
  if (props.sekou_cd) query["sekou_cd"] = props.sekou_cd;
  if (props.kouji_cd) query["kouji_cd"] = props.kouji_cd;
  if (props.plan_cd) query["plan_cd"] = props.plan_cd;
  return query;
});
</script>

<template>
  <NuxtLink
    class="bg-green-700 hover:bg-green-800 p-4 text-center rounded text-white"
    :to="{ path: '/inquiry/form', query }"
  >
    <slot>問い合わせする</slot>
  </NuxtLink>
</template>
